import React, { useState } from 'react';
import { useStore } from '../../../utils/store';
import { useNavigate } from 'react-router-dom';
import HttpService from '../../../services/HttpService';
import Constants from '../../../utils/constants';
import FormFieldData from '../../../Models/FormFieldData';
import { Stack } from '@mui/material';
import CommonForm from '../../../components/form/CommonForm';
import AlertMessageComponent from '../../../components/AlertMessageComponent';
import { useAlert } from '../../../components/alertContext';

const CrewsForm: React.FC = () => {
  const { getAdmin } = useStore();
  const navigate = useNavigate();

  type CrewsObj = {
    [k: string]: { required: boolean; value: string | null };
  };
  const [crewsForm, setCrewsForm] = useState<CrewsObj>({
    id: { required: false, value: null },
    name: { required: true, value: '' },
  });

  const [loading, setLoading] = useState(false);
  const { alert, setAlert, handleCloseAlert } = useAlert();

  const clearForm = () => {
    setCrewsForm({
      id: { required: false, value: null },
      name: { required: true, value: '' },
    });
    navigate('/data-management/crews');
  };

  const handleSave = async () => {
    setLoading(true);
    const reqData: any = {
      name: crewsForm.name.value,
    };
    const endpoint = `${Constants.apiURL + Constants.crewsURL}`;
    let response: any;
    try {
      response = await HttpService.post(endpoint, reqData, {
        headers: { Authorization: `Bearer ${getAdmin()}` },
      });

      if (response.success) {
        clearForm();
      }
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setCrewsForm((prevData) => ({
      ...prevData,
      [name]: { ...prevData[name], value: value },
    }));
  };

  const formFields: FormFieldData[] = [
    {
      name: 'name',
      label: 'Crew Name',
      value: crewsForm.name.value,
      onChange: handleInputChange,
      isRequired: crewsForm.name.required,
      size: 12,
      type: 'textfield',
      validationRules: [(value) => (!value ? 'Crew name is required' : '')],
    },
  ];

  return (
    <Stack>
      <CommonForm
        fields={formFields}
        onCancel={() => {}}
        formReset={clearForm}
        formTitle={'Add New Crew'}
        isLoading={loading}
        isUpdate={false}
        onSave={handleSave}
        actionButtonPosition="bottom"
      />
      <AlertMessageComponent
        type={alert.type}
        open={alert.open}
        handleClose={handleCloseAlert}
        message={alert.message}
      />
    </Stack>
  );
};

export default CrewsForm;
